import { useEffect, useState } from 'react';

import useAxiosAdminFetch from '../../hooks/useAxiosAdminFetch';
import {
  MESSAGES,
  buildStatementView,
  isEmptyStatement,
  toSaleMonth,
} from './settlementStatement.util';

function errorMessageOf(res) {
  const message = res?.data?.message;
  if (Array.isArray(message)) return message.join(' ');
  return message || MESSAGES.error;
}

/**
 * 정산월 하나의 정산명세서 조회. API에는 판매월(정산월 − 1)로 보낸다.
 * storeNo는 보내지 않는다(서버가 로그인 계정으로 고정).
 * useAxiosAdminFetch는 401 외 에러를 throw하지 않으므로 res.status로 나눈다.
 * 호출하는 쪽에서 정산월을 검증한 뒤 enabled로 넘긴다.
 * status: loading | ready | empty | message | auth(로그인 이동은 훅이 처리)
 */
export default function useSettlementStatement(payoutMonth, enabled = true) {
  const { fetchData } = useAxiosAdminFetch();
  const [result, setResult] = useState({ status: 'loading' });

  useEffect(() => {
    if (!enabled) return undefined;
    const saleMonth = toSaleMonth(payoutMonth);
    let cancelled = false;
    setResult({ status: 'loading' });
    (async () => {
      const res = await fetchData({
        url: 'settlement-statement',
        method: 'get',
        params: { saleFrom: saleMonth, saleTo: saleMonth },
      });
      if (cancelled) return;
      if (res?.status === 200 && res.data?.data) {
        const data = res.data.data;
        if (isEmptyStatement(data)) {
          setResult({ status: 'empty' });
          return;
        }
        setResult({ status: 'ready', view: buildStatementView(data) });
      } else if (res?.status === 401) {
        setResult({ status: 'auth' });
      } else if (res?.status === 409) {
        setResult({ status: 'message', message: MESSAGES.inProgress });
      } else if (res?.status === 403) {
        setResult({ status: 'message', message: MESSAGES.forbidden });
      } else {
        setResult({ status: 'message', message: errorMessageOf(res) });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [fetchData, payoutMonth, enabled]);

  return result;
}
